import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'hoursAgo',
  standalone: true
})
export class HoursAgoPipe implements PipeTransform {
 
  transform(value: string | Date): string {
    if (!value) return '';
 
    // Convert input to Date
    const givenDate = new Date(value);
 
    // Current time
    const now = new Date();
 
    // Difference in milliseconds
    const diffMs = now.getTime() - givenDate.getTime();
 
    
    const min = Math.floor(diffMs / 60000);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    if (min < 1) return 'Just now';
    if (min < 60) return `${min}min ago`;
    if (hr < 24) return `${hr}h ago`;
    return `${day}d ago`;
  }
}